import { render, staticRenderFns } from "./current_custom_plans.vue?vue&type=template&id=5fac674f&lang=pug&"
import script from "./current_custom_plans.vue?vue&type=script&lang=js&"
export * from "./current_custom_plans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports